exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes glyphicon-spin-r {\r\n    0% {\r\n        -webkit-transform: rotate(0deg);\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n        -webkit-transform: rotate(359deg);\r\n        transform: rotate(359deg);\r\n    }\r\n}\r\n.fast-right-spinner {\r\n    animation: glyphicon-spin-r 1s infinite linear;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/components/loadingspinner.css
// module id = 11
// module chunks = 0